import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=0c99db68&scoped=true&lang=pug&"
import script from "./Bag.vue?vue&type=script&lang=js&"
export * from "./Bag.vue?vue&type=script&lang=js&"
import style0 from "./Bag.vue?vue&type=style&index=0&id=0c99db68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99db68",
  null
  
)

export default component.exports